module.exports = __webpack_public_path__ + "img/defaultProfile.ea1ab901.png";